import { createStorage, StorageUtils } from '@ringba/core/storages';
import { LocalStorage, SessionStorage } from '@zajno/common-web/storage/index';

/** The app's typed browser storages, keyed and encoded as portal v3's `LocalStorages` and `SessionStorages`, so both portals on one origin share each key. */
export class AppStoragesProvider {
  /** @ngInject */
  constructor(cacheKey, whitelabelManager) {
    this._cacheKey = cacheKey;
    this._whitelabelManager = whitelabelManager;
  }

  /**
   * The app cache key, plus `_<wlPath>` under whitelabel.
   * Whitelabel resolves in this module's config phase, so read the prefix from a dependent module's config block or later.
   */
  get prefix() {
    const wlPath = this._whitelabelManager.value && this._whitelabelManager.value.path;
    return wlPath ? this._cacheKey + '_' + wlPath : this._cacheKey;
  }

  /** The service: `local` and `session` storages, both under {@link AppStoragesProvider#prefix}. */
  $get() {
    const utils = new StorageUtils(() => this.prefix);
    return {
      local: createStorage(LocalStorage, utils),
      session: createStorage(SessionStorage, utils),
    };
  }
}
